export const makeRestUrl = (path: string): string => {
  const sub_url = new URL(path, "https://protibimbok.github.io");
  const base = WPTB_CFG.WEB_URL;
  const url = new URL(`${base}/?rest_route=/wp-table-builder${sub_url.pathname}`);
  const search = new URLSearchParams(url.search);
  const sub_search = new URLSearchParams(sub_url.search);
  sub_search.forEach((value, key) => {
    search.set(key, value);
  });
  url.search = search.toString();
  return url.toString();
};

export type ApiPostDataTpe = FormData | Record<string, any>;

export const apiPost = async <T = any>(
  url: string,
  data: ApiPostDataTpe,
  init?: RequestInit
): Promise<[T, Response]> => {
  let body: any = data,
    contentType = "application/json";
  if (typeof data === "object" && !(data instanceof FormData)) {
    body = JSON.stringify(data);
  } else if (data instanceof FormData) {
    contentType = "multipart/form-data";
  }
  const response = await fetch(makeRestUrl(url), {
    ...init,
    method: "POST",
    body,
    headers: {
      "Content-Type": contentType,
      ...init?.headers,
      "X-WP-Nonce": WPTB_CFG.NONCE.wp_rest,
    },
  });
  return [(await response.json()) as T, response];
};

export const apiGet = async <T = any>(
  url: string,
  init?: RequestInit
): Promise<T> => {
  const response = await fetch(makeRestUrl(url), {
    ...init,
    headers: {
      ...init?.headers,
      "X-WP-Nonce": WPTB_CFG.NONCE.wp_rest,
    },
  });
  return await response.json();
};

export const apiDelete = async <T = any>(
  url: string,
  init?: RequestInit
): Promise<[T, Response]> => {
  const response = await fetch(makeRestUrl(url), {
    ...init,
    method: "DELETE",
    headers: {
      ...init?.headers,
      "X-WP-Nonce": WPTB_CFG.NONCE.wp_rest,
    },
  });
  return [(await response.json()) as T, response];
};

export const apiPatch = async <T = any>(
  url: string,
  data: Record<string, any>,
  init?: RequestInit
): Promise<[T, Response]> => {
  const response = await fetch(makeRestUrl(url), {
    ...init,
    method: "PATCH",
    body: JSON.stringify(data),
    headers: {
      "Content-Type": "application/json",
      ...init?.headers,
      "X-WP-Nonce": WPTB_CFG.NONCE.wp_rest,
    },
  });
  return [(await response.json()) as T, response];
};

/**
 * Download a file from the REST API (returns raw Response for binary handling)
 */
export const apiDownload = async (
  url: string,
  init?: RequestInit
): Promise<Response> => {
  return fetch(makeRestUrl(url), {
    ...init,
    headers: {
      ...init?.headers,
      "X-WP-Nonce": WPTB_CFG.NONCE.wp_rest,
    },
  });
};
